<script setup>
	import { computed } from 'vue';
	import { useMapStoreData } from '@/stores/index';
	import { useRoute } from 'vue-router';

	const route = useRoute();
	const id = computed(() => route.params.id);

	const backgroundImage = computed(() => {
		console.log('useMapStoreData().routes[id]: ', useMapStoreData().routes[id]);
		return useMapStoreData().routes[id.value].thumb.hash + '.' + useMapStoreData().routes[id.value].thumb.ext;
	});
</script>

<template>
	<div class="container" :style="{ backgroundImage: `url(${backgroundImage})` }">
		<div><router-link :to="'/'">Nazaj</router-link></div>
		{{ useMapStoreData().routes[id] }}
		<video :src="video"></video>
	</div>
</template>

<style scoped="scss">
	.container {
		width: 100vw;
		height: 100vh;
		background-size: cover;
		background-position: center;
	}
</style>
